import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectsmantri } from "../../../../data/projects/mantri/data";
import { projectspurvankara } from "../../../../data/projects/puravankara/data";

export const PurvankaraZenium2 = () => {
  const {
    zenium2: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectspurvankara;

  return (
    <>
      <Helmet>
        <title>Purva Zenium 2 Hosahalli, Bengaluru – Luxury Apartments by Puravankara</title>

        <meta
          name="description"
          content="Explore Purva Zenium 2 in Hosahalli, Bengaluru, by Puravankara. Premium 2 & 3 BHK smart homes with world-class amenities, excellent connectivity, and modern design. Book now!"
        />

        <meta
          name="keywords"
          content="Purva Zenium 2, Puravankara Purva Zenium 2, Purva Zenium 2 Hosahalli, Purva Zenium 2 Bengaluru, Puravankara Hosahalli, luxury apartments in Bengaluru, smart homes Bengaluru"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/puravankara-purva-zenium-2-hosahalli-bengaluru"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
